import React, { useEffect, useRef, useState } from "react";
import { Checkbox } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { useSnackbar } from "notistack";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import DateConversion from "../../../../../utils/DateConversion";
import CommaConvert from "../../../../../utils/CommaConvert";
import { setSelectedTaskId } from "../../../../../store/slices/ProjectOngoing/taskScrollSlice";
import ProgressTracker from "../../../../../utils/ProgressTracker";
import LoadingSpinner from "../../../../../components/common/loader/LoadingSpinner";


const OPTaskTrackPM = ({
  matchedOpWorkEntries,
  loggedUser,
  row,
  index,
  fetchWorkEntriesProjectTracking,
  setAggregateProgressMap,
  matchedProjectWorkEntries,
  matchedDescriptions,
  setIsLoading,
  showListState,
  isViewOnly = false
}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingRows, ] = useState({});
  const currency = useCurrencySymbol();
  const { formatDateByCountry, getDatePlaceholder, getDateFormat } = DateConversion();
  const USAComma = CommaConvert();

  const { loading, error } = useSelector((state) => state.projectOngoing);
  const selectedTaskId = useSelector((state) => state.taskScroll.selectedTaskId);
  console.log("selectedTaskId", selectedTaskId)

  const [opTrackWorkEntries, setOpTrackWorkEntries] = useState([]);
  useEffect(() => {
    setOpTrackWorkEntries(matchedOpWorkEntries);
  }, [matchedOpWorkEntries]);


  const [shouldScroll, setShouldScroll] = useState(false);

  useEffect(() => {
    if (selectedTaskId) {
      setShouldScroll(true);  // scroll later when rows exist
    }
  }, [selectedTaskId]);


  const refs = useRef({}); // store refs by task id

  useEffect(() => {
    if (
      shouldScroll &&
      selectedTaskId &&
      opTrackWorkEntries.length > 0 &&
      refs.current[selectedTaskId]
    ) {
      refs.current[selectedTaskId].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      setShouldScroll(false); // prevent repeating
      dispatch(setSelectedTaskId(null));
    }
  }, [shouldScroll, selectedTaskId, opTrackWorkEntries, dispatch]);






  useEffect(() => {
    if (error) {
      enqueueSnackbar(error, { variant: "error" });
    }
  }, [loading, error, enqueueSnackbar]);

  const [checkedRows] = useState({});

  useEffect(() => {
    if (!opTrackWorkEntries?.length) {
      setAggregateProgressMap({});
      return;
    }
    const progressMap = {};
    opTrackWorkEntries.forEach((entry) => {
      const projectId = entry.projectid;

      if (!progressMap[projectId]) {
        progressMap[projectId] = { totalTasks: 0, completedTasks: 0 };
      }

      progressMap[projectId].totalTasks += 1;
      if (entry.isTaskComplete) {
        progressMap[projectId].completedTasks += 1;
      }
    });

    // calculate percentage for each project
    const aggregateMap = {};
    Object.keys(progressMap).forEach((projectId) => {
      const { totalTasks, completedTasks } = progressMap[projectId];
      aggregateMap[projectId] =
        totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;
    });

    setAggregateProgressMap(aggregateMap);
  }, [opTrackWorkEntries, setAggregateProgressMap]);

  const [editedTask, ] = useState({});
  const [editedNotes, ] = useState({});
  const [editedDescription, ] = useState({});
  const [editedDescriptionNotes, ] = useState({});

  // const handleDescriptionExpensesUpdate = async (entryId) => {
  //   const value = editedDescription[entryId]; // get the value for this specific task
  //   if (!entryId) return;
  //   const updatedData = {
  //     expenses: Number(value),
  //   }
  //   try {
  //     await dispatch(
  //       updateOngoingDescription({
  //         projectId: row?._id,
  //         id: entryId,
  //         updatedData,
  //       })
  //     );
  //     dispatch(fetchWorkEntriesProjectTracking());
  //     dispatch(fetchDescriptionTasksProjectTracking());
  //   } catch {
  //     enqueueSnackbar("Failed To Add Date", { variant: "error" });
  //   } finally {
  //     setLoadingRows((prev) => ({ ...prev, [entryId]: false }));
  //     setIsLoading(false);
  //   }
  // };

  // const handleDescriptionNotesUpdate = async (entryId) => {
  //   const value = editedDescriptionNotes[entryId]; // get the value for this specific task
  //   if (!entryId) return;
  //   const updatedData = {
  //     notes: value,
  //   }
  //   try {
  //     await dispatch(
  //       updateOngoingDescription({
  //         projectId: row?._id,
  //         id: entryId,
  //         updatedData,
  //       })
  //     );
  //     dispatch(fetchWorkEntriesProjectTracking());
  //     dispatch(fetchDescriptionTasksProjectTracking());
  //   } catch {
  //     enqueueSnackbar("Failed To Add Date", { variant: "error" });
  //   } finally {
  //     setLoadingRows((prev) => ({ ...prev, [entryId]: false }));
  //     setIsLoading(false);
  //   }
  // };

  // const handleUpdateHours = async (taskId) => {
  //   const value = editedTask[taskId]; // get the value for this specific task
  //   if (!taskId) return;
  //   const projectid = row?._id;
  //   const updatedData = {
  //     hoursspent: Number(value),
  //   }
  //   try {
  //     await dispatch(
  //       updateTaskHours({
  //         projectid,
  //         taskownerid: taskId,
  //         updatedData
  //       })
  //     ).unwrap();
  //   } catch (err) {
  //     enqueueSnackbar(err, { variant: "error" });
  //   } finally {
  //     dispatch(fetchWorkEntriesProjectTracking());
  //     dispatch(fetchDescriptionTasksProjectTracking());
  //   }
  // };

  // const handleUpdateNotes = async (taskId) => {
  //   const value = editedNotes[taskId]; // get the value for this specific task

  //   if (!taskId) return;
  //   const projectid = row?._id;
  //   const updatedData = {
  //     notes: value,
  //   }
  //   try {
  //     await dispatch(
  //       updateTaskHours({
  //         projectid,
  //         taskownerid: taskId,
  //         updatedData
  //       })
  //     ).unwrap();
  //   } catch (err) {
  //     enqueueSnackbar(err, { variant: "error" });
  //   } finally {
  //     dispatch(fetchWorkEntriesProjectTracking());
  //     dispatch(fetchDescriptionTasksProjectTracking());
  //   }
  // };

  // const handleTaskMarkComplete = async (entry) => {
  //   const projectid = row?._id;
  //   const taskid = entry?._id;
  //   setLoadingRows((prev) => ({ ...prev, [entry?._id]: true }));
  //   setIsLoading(true);
  //   try {
  //     await dispatch(markComplete({ projectid, taskid }));
  //     dispatch(fetchWorkEntriesProjectTracking());
  //     enqueueSnackbar("Task Completed Successfully", { variant: "success" });
  //   } catch {
  //     enqueueSnackbar("Failed To Complete Task", { variant: "error" });
  //   } finally {
  //     setLoadingRows((prev) => ({ ...prev, [entry?._id]: false }));
  //     setIsLoading(false);
  //   }
  // };

  // const handleMarkNonComplete = async (entry) => {
  //   const projectid = row?._id;
  //   const taskid = entry?._id;
  //   setLoadingRows((prev) => ({ ...prev, [entry?._id]: true }));
  //   setIsLoading(true);
  //   try {
  //     await dispatch(markNonComplete({ projectid, taskid }));
  //     dispatch(fetchWorkEntriesProjectTracking());
  //     enqueueSnackbar("Task Not-Completed Successfully", {
  //       variant: "success",
  //     });
  //     dispatch(fetchAllProjects());
  //   } catch {
  //     enqueueSnackbar("Failed To Non-Complete Task", { variant: "error" });
  //   } finally {
  //     setLoadingRows((prev) => ({ ...prev, [entry?._id]: false }));
  //     setIsLoading(false);
  //   }
  // };

  // const handlemarkDescriptionComplete = async (entry) => {
  //   const projectid = row?._id;
  //   const taskid = entry?._id;
  //   setLoadingRows((prev) => ({ ...prev, [entry?._id]: true }));
  //   setIsLoading(true);
  //   try {
  //     await dispatch(markDescriptionComplete({ projectid, taskid }));
  //     dispatch(fetchWorkEntriesProjectTracking());
  //     dispatch(fetchDescriptionTasksProjectTracking());
  //     enqueueSnackbar("Description Completed Successfully", {
  //       variant: "success",
  //     });
  //   } catch {
  //     enqueueSnackbar("Failed To Non-Complete Task", { variant: "error" });
  //   } finally {
  //     setLoadingRows((prev) => ({ ...prev, [entry?._id]: false }));
  //     setIsLoading(false);

  //   }
  // };

  // const handlemarkNotDescriptionComplete = async (entry) => {
  //   const projectid = row?._id;
  //   const taskid = entry?._id;
  //   setLoadingRows((prev) => ({ ...prev, [entry?._id]: true }));
  //   setIsLoading(true);
  //   try {
  //     await dispatch(markNotDescriptionComplete({ projectid, taskid }));
  //     dispatch(fetchWorkEntriesProjectTracking());
  //     dispatch(fetchDescriptionTasksProjectTracking());
  //     enqueueSnackbar("Description Not-Completed Successfully", {
  //       variant: "success",
  //     });
  //   } catch {
  //     enqueueSnackbar("Failed To Non-Complete Task", { variant: "error" });
  //   } finally {
  //     setLoadingRows((prev) => ({ ...prev, [entry?._id]: false }));
  //     setIsLoading(false);

  //   }
  // };

  const [updatedDateDescription, ] = useState({})

  // const handleDescriptionDateSubmit = useCallback(async (entry) => {
  //   const matchedEntry = updatedDateDescription[entry._id] || {};
  //   const matchedStartDate = matchedEntry.startdate || null;
  //   const matchedEndDate = matchedEntry.enddate || null;

  //   const updatedData = {
  //     description: entry.description,
  //     value: entry.value,
  //     notes: entry.notes,
  //     typeservice: entry.typeservice,
  //     // startdate: matchedEntry.startdate || matchedStartDate,
  //     // enddate: matchedEntry.enddate || matchedEndDate,
  //     startdate: matchedStartDate ?? entry.startdate ?? null,
  //     enddate: matchedEndDate ?? entry.enddate ?? null,
  //   };

  //   try {
  //     await dispatch(
  //       updateOngoingDescription({
  //         projectId: row?._id,
  //         id: entry._id,
  //         updatedData,
  //       })
  //     );
  //     dispatch(fetchWorkEntriesProjectTracking());
  //     dispatch(fetchDescriptionTasksProjectTracking());
  //   } catch {
  //     enqueueSnackbar("Failed To Add Date", { variant: "error" });
  //   } finally {
  //     setLoadingRows((prev) => ({ ...prev, [entry?._id]: false }));
  //     setIsLoading(false);
  //   }
  // }, [updatedDateDescription, dispatch, row, fetchWorkEntriesProjectTracking, enqueueSnackbar, setLoadingRows, setIsLoading]);

  // const handleDescriptionDateChange = useCallback((date, field, entry) => {
  //   setUpdatedDateDescription(prev => ({
  //     ...prev,
  //     [entry._id]: {
  //       ...prev[entry._id],
  //       [field]: date,
  //     },
  //   }));

  //   if (field === "enddate") {
  //     const newentry = {
  //       ...entry,
  //       enddate: date
  //     }
  //     handleDescriptionDateSubmit(newentry)
  //   }
  // }, [handleDescriptionDateSubmit]);




  const [updatedDateWorkEntries, ] = useState({})

  // const handleWorkEntriesDateSubmit = useCallback(async (entry) => {
  //   const matchedEntry = updatedDateWorkEntries[entry._id] || {};
  //   const matchedStartDate = matchedEntry.startdate || null;
  //   const matchedEndDate = matchedEntry.enddate || null;

  //   const updatedData = {
  //     // startdate: matchedEntry.startdate || matchedStartDate,
  //     // enddate: matchedEntry.enddate || matchedEndDate,
  //     startdate: matchedStartDate ?? entry.startdate ?? null,
  //     enddate: matchedEndDate ?? entry.enddate ?? null,
  //   };
  //   try {
  //     await dispatch(
  //       updateTaskHours({
  //         projectid: row?._id,
  //         taskownerid: entry?._id,
  //         updatedData
  //       })
  //     );
  //     dispatch(fetchWorkEntriesProjectTracking());
  //     dispatch(fetchDescriptionTasksProjectTracking());
  //   } catch {
  //     enqueueSnackbar("Failed To Add Date", { variant: "error" });
  //   } finally {
  //     setLoadingRows((prev) => ({ ...prev, [entry?._id]: false }));
  //     setIsLoading(false);
  //   }
  // }, [updatedDateWorkEntries, row, dispatch, fetchWorkEntriesProjectTracking, enqueueSnackbar, setLoadingRows, setIsLoading]);

  // const workEntriesDateChange = useCallback((date, field, entry) => {
  //   setUpdatedDateWorkEntries(prev => ({
  //     ...prev,
  //     [entry._id]: {
  //       ...prev[entry._id],
  //       [field]: date,
  //     },
  //   }));

  //   if (field === "enddate") {
  //     const newentry = {
  //       ...entry,
  //       enddate: date
  //     }
  //     handleWorkEntriesDateSubmit(newentry)
  //   }
  // }, [handleWorkEntriesDateSubmit]);


  return (
    <div onClick={(e) => (e.stopPropagation())}>
      {showListState === "tasktable" && (
        <div className="w-full max-h-[24rem] overflow-y-auto overflow-x-hidden">
          {/* Header */}
          <div className=" z-[50] sticky top-0 flex bg-[#e8e8e8] text-black text-[10px] font-semibold break-words whitespace-normal">
            <div className="p-1 w-[10%] text-center"
            >
              Tasks
            </div>
            <div className="p-1 w-[10%] text-center">
              Hours Assigned
            </div>{" "}
            <div className="p-1 w-[10%] text-center">
              Hours Spent
            </div>{" "}
            <div className="p-1 w-[13%] text-center">
              Start Date
            </div>
            <div className="p-1 w-[13%]">End Date</div>
            <div className="p-1 w-[10%]">Notes</div>
            <div className="p-1 w-[24%] text-center">
              Tracker
            </div>
            <div className="p-1 w-[10%] text-center">
              Action
            </div>
          </div>

          <div
            className="flex text-[10px] break-all whitespace-normal max-h-14"
          >
            <div className="p-1 border-b border-[#dee2e6] w-[10%]">
              {"Total"}
            </div>
            <div className="p-1 border-b border-[#dee2e6] w-[10%]">
              {opTrackWorkEntries.reduce((sum, item) => sum + (item?.hoursassigned || 0), 0)}
            </div>
            <div className="p-1 border-b border-[#dee2e6] w-[10%] text-center">
              {opTrackWorkEntries.reduce((sum, item) => sum + (item?.hoursspent || 0), 0)}
            </div>
            <div className="p-1 border-b border-[#dee2e6] w-[13%] text-center">
            </div>
            <div className="p-1 border-b border-[#dee2e6] w-[13%] text-center">
            </div>
            <div className="p-1 border-b border-[#dee2e6] w-[10%] text-center">
            </div>
            <div className="p-2.5 border-b border-[#dee2e6] w-[24%] text-center">
              {opTrackWorkEntries.every((entry) => entry.isTaskComplete) ? (
                <>
                  {(() => {
                    const hoursAssigned = opTrackWorkEntries.reduce(
                      (sum, item) => sum + (item?.hoursassigned || 0),
                      0
                    );
                    const hoursSpent = opTrackWorkEntries.reduce(
                      (sum, item) => sum + (item?.hoursspent || 0),
                      0
                    );

                    const trackerPercentage =
                      hoursAssigned > 0 ? (hoursSpent / hoursAssigned) * 100 : 0;

                    const displayValue = trackerPercentage < 100 ? 100 : trackerPercentage;

                    return <ProgressTracker value={displayValue} />;
                  })()}                   </>
              ) : (
                <>
                  {(() => {
                    const hoursAssigned = opTrackWorkEntries.reduce((sum, item) => sum + (item?.hoursassigned || 0), 0);
                    const hoursSpent = opTrackWorkEntries.reduce((sum, item) => sum + (item?.hoursspent || 0), 0);
                    const trackerPercentage = hoursAssigned > 0 ? (hoursSpent / hoursAssigned) * 100 : 0;
                    return <ProgressTracker value={trackerPercentage} />;
                  })()}
                </>
              )}

            </div>
            <div className="p-1 border-b border-[#dee2e6] w-[10%] text-center">
            </div>
          </div>

          {opTrackWorkEntries.length > 0 ? (
            opTrackWorkEntries.map((entry, index) => (
              <div
                // ref={(el) => (refs.current[entry._id] = el)}
                key={entry?._id}
                className="flex text-[10px] break-all whitespace-normal cursor-pointer"
              >
                <div className="p-1 border-b flex flex-col border-[#dee2e6] w-[10%] break-words whitespace-normal">
                  <p className="text-[10px]" title={`${entry.task}`}> {entry.task} </p>
                  {(() => {
                    // Only show ⏳ if task is not complete and enddate is within next 2 days
                    if (entry.enddate && !entry.isTaskComplete) {
                      const endDate = new Date(entry.enddate);
                      const today = new Date();
                      const twoDaysFromNow = new Date();
                      twoDaysFromNow.setDate(today.getDate() + 2);

                      // Set hours to 0 to compare only dates
                      today.setHours(0, 0, 0, 0);
                      endDate.setHours(0, 0, 0, 0);
                      twoDaysFromNow.setHours(0, 0, 0, 0);

                      // Check if enddate is today or within next 2 days
                      if (endDate >= today && endDate <= twoDaysFromNow) {
                        return <span
                          title="You have upcoming deadline in 2 days"
                          className="text-orange-300 text-xs"> ⏳ </span>;
                      }
                    }
                    return null;
                  })()}
                </div>
                <div className="p-1 border-b border-[#dee2e6] w-[10%]">
                  {entry.hoursassigned}
                </div>
                <div className="p-1 border-b border-[#dee2e6] w-[10%] text-center">
                  {entry.isTaskComplete ? (
                    <span>{entry.hoursspent || ""}</span>
                  ) : (
                    <input
                      readOnly={true}
                      type="text"
                      value={editedTask[entry._id] ?? entry.hoursspent ?? ""}
                      placeholder="enter hours"
                      className="border border-gray-200 w-full rounded-md max-w-full p-1 text-center"
                    //  onChange={(e) => {
                    //    const value = e.target.value;
                    //    if (!/^\d*$/.test(value)) return;
                    //    if (value > entry.hoursassigned) {
                    //      enqueueSnackbar("Hours Spent is exceeding the Hours Assigned", {
                    //        variant: "error",
                    //      });
                    //    }
                    //    if (Number(value) < 0) return;
                    //    setEditedTask((prev) => ({
                    //      ...prev,
                    //      [entry._id]: value, // store by task id
                    //    }));
                    //  }}
                    //  onBlur={() => handleUpdateHours(entry._id)}
                    />
                  )}
                </div>
                <div className="p-1 border-b border-[#dee2e6] w-[13%] text-center">
                  {entry.isTaskComplete ? (
                    <div className="text-black">
                      {entry.startdate
                        ? formatDateByCountry(entry.startdate)
                        : ""}
                    </div>
                  ) : (
                    <DatePicker
                      readOnly={true}
                      dateFormat={getDateFormat()}
                      className="w-full h-full text-center outline-none border p-1 border-gray-300 rounded-md bg-white"
                      placeholderText={getDatePlaceholder()}
                      popperClassName="z-[1500]"
                      selected={
                        updatedDateWorkEntries[entry._id]?.startdate
                          ? updatedDateWorkEntries[entry._id].startdate
                          : entry.startdate
                            ? new Date(entry.startdate)
                            : null
                      }
                    //  onChange={(date) => workEntriesDateChange(date, 'startdate', entry)}
                    />)}
                </div>
                <div className="p-1 border-b border-[#dee2e6] w-[13%] text-center">
                  {(entry.isTaskComplete || entry.enddate) ? (
                    <div className="text-black">
                      {entry.enddate
                        ? formatDateByCountry(entry.enddate)
                        : ""}
                    </div>
                  ) : (
                    <DatePicker
                        readOnly={true}
                      dateFormat={getDateFormat()}
                      className="w-full h-full text-center outline-none border p-1 border-gray-300 rounded-md bg-white"
                      placeholderText={getDatePlaceholder()}
                      popperClassName="z-[1500]"
                      minDate={
                        // ✅ Use updated startdate if available, else fallback to entry.startdate
                        updatedDateWorkEntries[entry._id]?.startdate
                          ? new Date(updatedDateWorkEntries[entry._id].startdate)
                          : entry.startdate
                            ? new Date(entry.startdate)
                            : null
                      }
                      selected={
                        updatedDateWorkEntries[entry._id]?.enddate
                          ? updatedDateWorkEntries[entry._id].enddate
                          : entry.enddate
                            ? new Date(entry.enddate)
                            : null
                      } 
                      // onChange={(date) => workEntriesDateChange(date, 'enddate', entry)}
                    />)}
                </div>
                <div
                  title={`${entry.notes}`}
                  className="p-1 border-b border-[#dee2e6] w-[10%] text-center break-words whitespace-normal">
                  {/* {entry.notes || ""} */}
                  {entry.isTaskComplete ? (
                    <span>{entry.notes || ""}</span>
                  ) : (
                    <input
                        readOnly={true}
                      type="text"
                      value={editedNotes[entry._id] ?? entry.notes ?? ""}
                      placeholder="enter note"
                      className="border border-gray-200 w-full max-w-full p-1 rounded-md text-center"
                      // onChange={(e) => {
                      //   const value = e.target.value;
                      //   setEditedNotes((prev) => ({
                      //     ...prev,
                      //     [entry._id]: value,
                      //   }));
                      // }}
                      // onBlur={() => handleUpdateNotes(entry._id)}
                    />
                  )}
                </div>
                <div className="p-2.5 border-b border-[#dee2e6] w-[24%] text-center">
                  {entry.isTaskComplete ?
                    <ProgressTracker
                      value={
                        (() => {
                          const rawValue =
                            ((Number(entry.hoursspent) || 0) /
                              entry.hoursassigned) *
                            100;
                          return rawValue < 100 ? 100 : rawValue;
                        })()
                      }
                    />
                    :
                    <ProgressTracker
                      value={
                        ((Number(editedTask[entry._id] ?? entry.hoursspent) || 0) /
                          entry.hoursassigned) *
                        100
                      }
                    />
                  }
                </div>
                <div className="p-1 border-b border-[#dee2e6] w-[10%] text-center cursor-pointer">
                  {loadingRows[index] ? (
                    <LoadingSpinner />
                  ) : (
                    <Checkbox
                      disabled={true}
                      checked={entry.isTaskComplete || !!checkedRows[index]}
                      // onChange={(e) => {
                      //   const isChecked = e.target.checked;

                      //   const currentHours = Number(
                      //     editedTask[entry._id] ?? entry.hoursspent
                      //   );

                      //   const startDate =
                      //     updatedDateWorkEntries[entry._id]?.startdate || entry.startdate;
                      //   const endDate =
                      //     updatedDateWorkEntries[entry._id]?.enddate || entry.enddate;

                      //   if (isChecked) {
                      //     if (!currentHours || currentHours <= 0) {
                      //       enqueueSnackbar(
                      //         "Please enter hours spent before completing task",
                      //         { variant: "error" }
                      //       );
                      //       e.preventDefault();
                      //       return;
                      //     }
                      //     if (!startDate || !endDate) {
                      //       enqueueSnackbar("Please Select End Date", {
                      //         variant: "error",
                      //       });
                      //       return;
                      //     }
                      //     handleTaskMarkComplete(entry, index);
                      //     handleWorkEntriesDateSubmit(entry)
                      //   } else {
                      //     handleMarkNonComplete(entry);
                      //   }
                      // }}
                    />
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="flex text-[14px] break-all whitespace-normal max-h-14 p-1">
              <p className="text-red-500 text-center">
                {" "}
                No Tracking Task Entries Found
              </p>
            </div>
          )}
        </div>
      )}


      {showListState === "otherexpenses" && (
        <div className="w-full max-h-[24rem] overflow-y-auto overflow-x-hidden">
          <div className="z-[50] sticky top-0 flex bg-[#e8e8e8] text-black text-[10px] font-semibold break-words whitespace-normal">
            <div className="p-1 w-[10%] text-center">
              Description
            </div>
            <div className="p-1 w-[10%] text-center">
              Amount ({currency})
            </div>
            <div className="p-1 w-[13%] text-center">
              Start Date
            </div>
            <div className="p-1 w-[13%] text-center">
              End Date
            </div>
            <div className="p-1 w-[10%]">Notes</div>
            <div className="p-1 w-[10%] text-center">
              Expenses ({currency})
            </div>
            <div className="p-1 w-[24%] text-center">
              Tracker
            </div>
            <div className="p-1 w-[10%] text-center">
              Action
            </div>
          </div>


          <div
            className="flex text-[10px] break-all whitespace-normal max-h-14"
          >
            <div className="p-1 text-center border-b border-[#dee2e6] w-[10%]">
              {"Total"}
            </div>
            <div className="p-1 border-b border-[#dee2e6] w-[10%]">
              {USAComma(matchedDescriptions.reduce((sum, item) => sum + (item?.value || 0), 0))}
            </div>

            <div className="p-1 border-b border-[#dee2e6] w-[13%] text-center">
            </div>
            <div className="p-1 border-b border-[#dee2e6] w-[13%] text-center">
            </div>
            <div className="p-1 border-b border-[#dee2e6] w-[10%] text-center">
            </div>
            <div className="p-1 border-b border-[#dee2e6] w-[10%] text-center">
              {USAComma(matchedDescriptions.reduce((sum, item) => sum + (item?.expenses || 0), 0))}
            </div>
            <div className="p-2.5 border-b border-[#dee2e6] w-[24%] text-center">
              {matchedDescriptions.every((entry) => entry.isTaskComplete) ? (
                <>
                  {(() => {
                    const hoursAssigned = matchedDescriptions.reduce(
                      (sum, item) => sum + (item?.value || 0),
                      0
                    );
                    const hoursSpent = matchedDescriptions.reduce(
                      (sum, item) => sum + (item?.expenses || 0),
                      0
                    );

                    const trackerPercentage =
                      hoursAssigned > 0 ? (hoursSpent / hoursAssigned) * 100 : 0;

                    const displayValue = trackerPercentage < 100 ? 100 : trackerPercentage;

                    return <ProgressTracker value={displayValue} />;
                  })()}                   </>
              ) : (
                <>
                  {(() => {
                    const allEntries = matchedDescriptions?.reduce((sum, item) => sum + (item?.value || 0), 0);
                    const completedEntriesCount = matchedDescriptions?.reduce((sum, item) => sum + (item?.expenses || 0), 0);
                    const trackerPercentage = allEntries > 0 ? (completedEntriesCount / allEntries) * 100 : 0;
                    return <ProgressTracker value={trackerPercentage} />;
                  })()}
                </>)}
            </div>
            <div className="p-1 border-b border-[#dee2e6] w-[10%] text-center">
            </div>
          </div>

          {matchedDescriptions.length > 0 ? (
            matchedDescriptions.map((entry, index) => (
              <div
                key={entry}
                className="flex text-[10px] break-words whitespace-normal cursor-default"
              >
                <div className="p-1 border-b border-[#dee2e6] w-[10%]"
                  title={`${entry.description}`}
                >
                  {entry.description}
                </div>
                <div className="p-1 border-b border-[#dee2e6] w-[10%]">
                  {USAComma(entry.value)}
                </div>
                <div className="p-1 border-b border-[#dee2e6] w-[13%] text-center">
                  {entry.isTaskComplete ? (
                    <div className="text-black">
                      {entry.startdate
                        ? formatDateByCountry(entry.startdate)
                        : ""}
                    </div>
                  ) : (
                    <DatePicker
                        readOnly={true}
                      dateFormat={getDateFormat()}
                      className="w-full h-full text-center outline-none border p-1 border-gray-300 rounded-md bg-white"
                      placeholderText={getDatePlaceholder()}
                      popperClassName="z-[1500]"
                      selected={
                        updatedDateDescription[entry._id]?.startdate
                          ? updatedDateDescription[entry._id].startdate
                          : entry.startdate
                            ? new Date(entry.startdate)
                            : null
                      } 
                      // onChange={(date) => handleDescriptionDateChange(date, 'startdate', entry)}
                    />)}
                </div>
                <div className="p-1 border-b border-[#dee2e6] w-[13%] text-center">
                  {(entry.isTaskComplete || entry.enddate) ? (
                    <div className="text-black">
                      {entry.enddate
                        ? formatDateByCountry(entry.enddate)
                        : ""}
                    </div>
                  ) : (
                    <DatePicker
                        readOnly={true}
                      dateFormat={getDateFormat()}
                      className="w-full h-full text-center outline-none border p-1 border-gray-300 rounded-md bg-white"
                      placeholderText={getDatePlaceholder()}
                      popperClassName="z-[1500]"
                      minDate={
                        // ✅ Use updated startdate if available, else fallback to entry.startdate
                        updatedDateDescription[entry._id]?.startdate
                          ? new Date(updatedDateDescription[entry._id].startdate)
                          : entry.startdate
                            ? new Date(entry.startdate)
                            : null
                      }
                      selected={
                        updatedDateDescription[entry._id]?.enddate
                          ? updatedDateDescription[entry._id].enddate
                          : entry.enddate
                            ? new Date(entry.enddate)
                            : null
                      } 
                      // onChange={(date) => handleDescriptionDateChange(date, 'enddate', entry)}
                    />)}
                </div>
                <div className="p-1 border-b border-[#dee2e6] w-[10%] text-center break-all whitespace-normal "
                  title={`${entry.notes}`}
                >
                  {/* {entry.notes} */}
                  {entry.isTaskComplete ? (
                    <span>{entry.notes || ""}</span>
                  ) : (
                    <input
                        readOnly={true}
                      type="text"
                      value={editedDescriptionNotes[entry._id] ?? entry.notes ?? ""}
                      placeholder="enter note"
                      className="border border-gray-200 w-full max-w-full p-1 rounded-md text-center"
                      // onChange={(e) => {
                      //   const value = e.target.value;
                      //   setEditedDescriptionNotes((prev) => ({
                      //     ...prev,
                      //     [entry._id]: value,
                      //   }));
                      // }}
                      // onBlur={() => handleDescriptionNotesUpdate(entry._id)}
                    />
                  )}
                </div>
                <div className="p-1 border-b border-[#dee2e6] w-[10%] text-center">
                  {entry.isTaskComplete ? (
                    // 👇 Just show saved hours if complete
                    <span>{USAComma(entry.expenses) || ""}</span>
                  ) : (
                    // 👇 Editable input if not complete
                    <input
                        readOnly={true}
                      type="text"
                      value={editedDescription[entry._id] ?? USAComma(entry.expenses) ?? ""}
                      placeholder="enter expense spent"
                      className="border border-gray-200 w-full rounded-md max-w-full p-1 text-center"
                      // onChange={(e) => {
                      //   const value = e.target.value;
                      //   if (!/^\d*$/.test(value)) return;
                      //   if (value > entry.value) {
                      //     enqueueSnackbar("Expenses is exceeding the Amount", {
                      //       variant: "error",
                      //     });
                      //   }
                      //   if (Number(value) < 0) return;
                      //   setEditedDescription((prev) => ({
                      //     ...prev,
                      //     [entry._id]: value, // store by task id
                      //   }));
                      // }}
                      // onBlur={() => handleDescriptionExpensesUpdate(entry._id)}
                    />
                  )}
                </div>
                <div className="p-2.5 border-b border-[#dee2e6] w-[24%] text-center">
                  {entry.isTaskComplete ?

                    <ProgressTracker
                      value={
                        (() => {
                          const rawValue =
                            ((Number(entry.expenses) || 0) /
                              entry.value) *
                            100;
                          return rawValue < 100 ? 100 : rawValue;
                        })()
                      }
                    />
                    :
                    <ProgressTracker
                      value={
                        ((Number(editedDescription[entry._id] ?? entry.expenses) || 0) /
                          entry.value) *
                        100
                      }
                    />
                  }                 </div>
                <div className="p-1 border-b border-[#dee2e6] w-[10%] text-center cursor-pointer">
                  {loadingRows[index] ? (
                    <LoadingSpinner />
                  ) : (

                    <Checkbox
                      disabled={true}
                      checked={entry.isTaskComplete}
                      // onChange={(e) => {
                      //   const isChecked = e.target.checked;
                      //   const currentExpenses = Number(
                      //     editedDescription[entry._id] ?? entry.expenses
                      //   );
                      //   const startDate =
                      //     updatedDateDescription[entry._id]?.startdate || entry.startdate;
                      //   const endDate =
                      //     updatedDateDescription[entry._id]?.enddate || entry.enddate;

                      //   if (isChecked) {
                      //     // ✅ Only validate when marking complete
                      //     if (!startDate || !endDate) {
                      //       enqueueSnackbar("Please Select End Date", {
                      //         variant: "error",
                      //       });
                      //       return;
                      //     }

                      //     if (!currentExpenses || currentExpenses <= 0) {
                      //       enqueueSnackbar("Please Enter Expense", {
                      //         variant: "error",
                      //       });
                      //       return;
                      //     }

                      //     handlemarkDescriptionComplete(entry, index);
                      //     handleDescriptionDateSubmit(entry);
                      //   } else {
                      //     // ✅ Allow unchecking freely (no validation)
                      //     handlemarkNotDescriptionComplete(entry);
                      //   }
                      // }}
                    />
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="flex text-[14px] break-words whitespace-normal max-h-14 p-1">
              <p className="text-red-500 text-center">
                {" "}
                No Tracking Task Entries Found
              </p>
            </div>
          )}
        </div>
      )}


      {matchedProjectWorkEntries.length > 0 &&
        matchedProjectWorkEntries.every((entry) => entry.isTaskComplete) && (
          <div className="flex justify-end p-2">
            {/* <button
                 onClick={handleCompleteProject}
                 className="bg-blue-500  hover:bg-blue-700 py-1 px-4 text-white rounded-md"
               >
                 Complete
               </button> */}
          </div>
        )}
    </div>
  )
}

export default OPTaskTrackPM